import callApi from './personnelService';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const getStoreDealer = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/sm/get-store-dealer`
});

export const getStores = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/sm/get-stores`,
  body: storeInfo
});

export const getIndexSa = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/sm/store-manage/index-sa`,
  body: storeInfo
});

export const getIndexCustomer = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/sm/store-manage/index-customer`,
  body: storeInfo
});

export const getIndexReservation = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/sm/store-manage/index-reservation`,
  body: storeInfo
});

export const getStorePersonnel = (store_id) => callApi({
  method: 'POST',
  endpoint: `${basePath}/sm/get-store-personnel`,
  body: {
    store_id
  }
});

export const updateSa = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/sm/store-manage/update-sa/${updateInfo.sa_id}`,
  body: updateInfo
});

export const getAssignSpDropdown = (formData) => callApi({
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  endpoint: `${basePath}/reservation/assign-sp-dropdown?${buildQueryUrlFromObject(formData)}`
});

export const assignReservation = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/reservation/assign-reservation`,
  body: formData
});

export const getStorePersonnelList = (id) => callApi({
  method: 'GET',
  endpoint: `${basePath}/sm/store-manage-transform/sa/${id}`
});

export const settingSaStatus = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/sm/store-manage-transform/sa`,
  body: formData
});
